



import React from 'react'
import "./Navbar.css";

function Navbar() {
  return (
    <div>
      <div className='fixed-top'>
        
      <div className='nadiahotel'>
          <div className="album py-2">
            <div className="container">
              <div className="row ">
               <div className="col-md-5" >
               <div className="d-flex justify-content-between align-items-center">

                   <a style={{color:"maroon"}} href="tel: +91 8798265619"  >Mob: <svg xmlns="http://www.w3.org/2000/svg" style={{color:"maroon"}} width="16" height="16" fill="currentColor" className="bi bi-telephone-forward" viewBox="0 0 16 16">
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                     </svg> 8798265619</a>


                     <a style={{color:"maroon"}} href="https://share.google/v5MxBKw1e1EFoKe61" target="_blank" rel="noopener noreferrer">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sign-merge-right" viewBox="0 0 16 16">
  <path d="M8.75 6v1q.211.451.588.95c.537.716 1.259 1.44 2.016 2.196l-.708.708-.015-.016c-.652-.652-1.33-1.33-1.881-2.015V12h-1.5V6H6.034a.25.25 0 0 1-.192-.41l1.966-2.36a.25.25 0 0 1 .384 0l1.966 2.36a.25.25 0 0 1-.192.41z"/>
  <path fill-rule="evenodd" d="M9.05.435c-.58-.58-1.52-.58-2.1 0L.436 6.95c-.58.58-.58 1.519 0 2.098l6.516 6.516c.58.58 1.519.58 2.098 0l6.516-6.516c.58-.58.58-1.519 0-2.098zm-1.4.7a.495.495 0 0 1 .7 0l6.516 6.515a.495.495 0 0 1 0 .7L8.35 14.866a.495.495 0 0 1-.7 0L1.134 8.35a.495.495 0 0 1 0-.7L7.65 1.134Z"/>
</svg> Direction </a>
                    


               </div>

             </div>

            <div className="d-flex justify-content-between align-items-center">





                </div>
             </div>
           </div>
         </div>
        </div>
       
        
      <nav className="navbar navbar-expand-lg navbar-white bg-white shadow">
  <div className="container-fluid">
    <a style={{color:"#11842C"}} className="navbar-brand name" href="/"><b>LODGE GREEN HOUSE</b></a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a style={{color:"#48340A"}} className="nav-link active" aria-current="page" href="/">Home</a>
        </li>
         <li className="nav-item">
          <a href='aboutus'  style={{color:"#48340A"}} className="nav-link " aria-current="page" >About us</a>
        </li>
           <li className="nav-item">
          <a href='seminar'  style={{color:"#48340A"}} className="nav-link " aria-current="page">Seminar Hall</a>
        </li>
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Room
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a className="dropdown-item" href="room">Room</a></li>
            {/* <li><a className="dropdown-item" href="#">Update</a></li>
            <li><hr className="dropdown-divider"/></li>
            <li><a className="dropdown-item" href="#">Update 2</a></li> */}
          </ul>
        </li>
                <li className="nav-item">
          <a href='https://www.google.com/search?q=lodge+green+house&sca_esv=f7534cda465baa9a&sxsrf=ANbL-n4xp24On6T00REQISKiOGG6o0VSjw%3A1771501050206&ei=-vWWac-fDMTcseMP36bj4AY&biw=1280&bih=585&oq=lodg&gs_lp=Egxnd3Mtd2l6LXNlcnAiBGxvZGcqAggAMgQQIxgnMgQQIxgnMgsQABiABBiRAhiKBTILEAAYgAQYkQIYigUyEBAAGIAEGLEDGEMYyQMYigUyChAAGIAEGEMYigUyCxAAGIAEGJIDGIoFMgoQABiABBhDGIoFMgoQABiABBhDGIoFMgoQABiABBgUGIcCSP8NUABYzgRwAHgBkAEAmAGhAqABsQiqAQMyLTS4AQHIAQD4AQGYAgSgAu8IwgIKECMYgAQYJxiKBcICCBAAGIAEGLEDwgIWEC4YgAQYsQMY0QMYQxiDARjHARiKBcICChAuGIAEGEMYigXCAg0QABiABBgUGIcCGMkDmAMAkgcFMi0zLjGgB64nsgcFMi0zLjG4B-8IwgcHMi0xLjIuMcgHNIAIAA&sclient=gws-wiz-serp#lrd=0x39f9203ba4ff5a07:0xd05f23778f5b6df1,3,,,,' target="_blank" rel="noopener noreferrer" style={{color:"#48340A"}} className="nav-link " aria-current="page" >Review</a>
        </li>
               
        <li className="nav-item">
          <a href='contact-us'  style={{color:"#48340A"}} className="nav-link " aria-current="page" >Contact us</a>
        </li>
      </ul>
     <a href='tel: 8798265619'>
        <button className="helpline" type="submit">Helpline No. 8798265619 </button>
        </a>
      
    </div>
  </div>
</nav>
 </div>
    </div>
  )
}

export default Navbar